module.exports = __webpack_public_path__ + "static/media/mobile.8a4d91e2.png";